export const ACTION_REQUIRED_MESSAGES_REQUEST = 'ACTION_REQUIRED_MESSAGES_REQUEST';
export const ACTION_REQUIRED_MESSAGES_SUCCESS = 'ACTION_REQUIRED_MESSAGES_SUCCESS';
export const ACTION_REQUIRED_MESSAGES_FAILURE = 'ACTION_REQUIRED_MESSAGES_FAILURE';

export const ACTION_REQUIRED_COUNT_REQUEST = 'ACTION_REQUIRED_COUNT_REQUEST';
export const ACTION_REQUIRED_COUNT_SUCCESS = 'ACTION_REQUIRED_COUNT_SUCCESS';
export const ACTION_REQUIRED_COUNT_FAILURE = 'ACTION_REQUIRED_COUNT_FAILURE';

export const ACTION_UPDATED_MESSAGES_REQUEST = 'ACTION_UPDATED_MESSAGES_REQUEST';
export const ACTION_UPDATED_MESSAGES_SUCCESS = 'ACTION_UPDATED_MESSAGES_SUCCESS';
export const ACTION_UPDATED_MESSAGES_FAILURE = 'ACTION_UPDATED_MESSAGES_FAILURE';

export const DELETE_MESSAGES = 'DELETE_MESSAGES';

export const HISTORY_REQUEST = 'HISTORY_REQUEST';
export const HISTORY_SUCCESS = 'HISTORY_SUCCESS';
export const HISTORY_FAILURE = 'HISTORY_FAILURE';

export const DISMISS_REQUEST = 'DISMISS_REQUEST';
export const DISMISS_SUCCESS = 'DISMISS_SUCCESS';
export const DISMISS_FAILURE = 'DISMISS_FAILURE';

export const DISMISS_ALL_REQUEST = 'DISMISS_ALL_REQUEST';
export const DISMISS_ALL_SUCCESS = 'DISMISS_ALL_SUCCESS';
export const DISMISS_ALL_FAILURE = 'DISMISS_ALL_FAILURE';

export const GET_HISTORY_DATA_NEXT_REQUEST = 'GET_HISTORY_DATA_NEXT_REQUEST';
export const GET_HISTORY_DATA_NEXT_SUCCESS = 'GET_HISTORY_DATA_NEXT_SUCCESS';
export const GET_HISTORY_DATA_NEXT_FAILURE = 'GET_HISTORY_DATA_NEXT_FAILURE';

export const SET_FAST_POLLING_REQUEST = 'SET_FAST_POLLING_REQUEST';
export const SET_SLOW_POLLING_REQUEST = 'SET_SLOW_POLLING_REQUEST';
export const START_POLLING = 'START_POLLING';
